import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Steps, Radio, Input, Modal, Button,
} from 'antd';
import { updateBlemishReportRequest } from '../../../redux/actions/questions_actions/update_blemish_report.actions';
import { getLeadProfileRequest } from '../../../redux/actions/get_lead_profile.actions';
import { setLeadValuationRequest } from '../../../redux/actions/set_lead_valuation.actions';
import { setLeadsCustomerValuationRequest } from '../../../redux/actions/set_customer_valuation.actions';

import { SFButton } from '../../../../../../components/SF-UI';
import { get, getVal } from '../../../../../../shared/helpers';

const { Step } = Steps;
const RadioGroup = Radio.Group;
const { Search } = Input;
const { confirm } = Modal;

class BlemishReportVersion2 extends React.Component {
    refArray = [];

    // ID of failed status in blemish report
    blemish_report_failed_status_id = '5c6bb394b8292a22d8128dff';

    // check for failed status, if failed === true, then we wont buy this bike, and blemish report is finished
    is_blemish_report_failed = this.props.blemish_report_status_id === this.blemish_report_failed_status_id;

    constructor(props) {
        super(props);
        this.state = {
            current: 0,
        };

        this.stepsArray = [
            this.divideQuestionsBySteps(1),
            this.divideQuestionsBySteps(2, 9),
            this.divideQuestionsBySteps(10, 11),
            this.divideQuestionsBySteps(12, 13),
            this.divideQuestionsBySteps(14),
            this.divideQuestionsBySteps(15, 23),
            this.divideQuestionsBySteps(24, 32),
            this.divideQuestionsBySteps(33, 38),
            this.divideQuestionsBySteps(39, 45),
            this.divideQuestionsBySteps(46),

        ];
    }

    stepsStyles = {
        stepsContent: {
            marginTop: 16,
            border: '1px dashed #e9e9e9',
            borderRadius: 6,
            backgroundColor: '#fafafa',
            minHeight: 200,
            padding: 10,
        },
        stepsAction: {
            marginTop: 24,
        },
    };


    componentWillMount() {
        this.startingStep(this.props.blemish_report.questions);
    }

    divideQuestionsBySteps = (from, to) => {
        const content = [];
        if (to === undefined) {
            content.push(
                this.props.blemish_report.questions[`question_${from}`],
            );
        } else {
            for (let i = from; i <= to; i++) {
                content.push(
                    this.props.blemish_report.questions[`question_${i}`],
                );
            }
        }
        return content;
    };

    next = (el, questionNumber) => {
        if (el && el.target.name === 'confirm') {
            this.props.updateBlemishReportRequest({ lead_id: this.props.lead_id, question: `question_${questionNumber}`, updateValue: true });
        }
        if (this.state.current !== 9) {
            const current = this.state.current + 1;
            this.setState({ current });
        }
    };

    finishBlemishReport = (el, questionNumber) => {
        if (this.props.blemish_report.questions[`question_${questionNumber}`].value === null) {
            this.props.updateBlemishReportRequest({ lead_id: this.props.lead_id, question: `question_${questionNumber}`, updateValue: true });
        }

        this.props.getLeadProfileRequest(this.props.lead_id);
        this.props.closeModal();
    };

    showDeleteConfirm = (e, params) => {
        confirm({
            title: 'Are you sure?',
            content: 'By clicking the \'Confirm\' button, the status of this bike will change to \'Won\'t Buy\' due to the issue highlighted in the Blemish Report',
            okText: 'Confirm',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: () => {
                this.props.updateBlemishReportRequest({ lead_id: this.props.lead_id, question: `question_${params.questionNumber}`, updateValue: false });
            },
            onCancel: () => {
                if (this.props.blemish_report.questions[`question_${params.questionNumber}`].value === true) {
                    this.refArray[`question_${params.questionNumber}`].setState({ value: true });
                } else if (this.props.blemish_report.questions[`question_${params.questionNumber}`].value === null) {
                    this.refArray[`question_${params.questionNumber}`].setState({ value: null });
                }
            },
        });
    };

    questionAnswer = (e, params) => {
        if (e.target) {
            if (params.questionNumber === 10 && e.target.value === false) {
                this.props.updateBlemishReportRequest(
                    { lead_id: this.props.lead_id, question: `question_${params.questionNumber}`, updateValue: e.target.value },
                    { question_11: { value: true } },
                );
            } else if (getVal(params, 'question.category') === 7 && e.target.value === false) {
                this.props.updateBlemishReportRequest({
                    lead_id: this.props.lead_id, question: `question_${params.questionNumber}`, updateValue: false, note: '',
                });
            } else {
                this.props.updateBlemishReportRequest({ lead_id: this.props.lead_id, question: `question_${params.questionNumber}`, updateValue: e.target.value });
            }
        } else if (params.questionNumber === 9) {
            this.props.setLeadsCustomerValuationRequest(this.props.lead_id, Number(e), this.props.currentUserId);
            this.props.updateBlemishReportRequest({
                lead_id: this.props.lead_id, question: `question_${params.questionNumber}`, updateValue: true, note: e,
            });
        } else if (params.price_negotiate) {
            this.props.setLeadValuationRequest(this.props.lead_id, Number(e));
        } else {
            this.props.updateBlemishReportRequest({
                lead_id: this.props.lead_id, question: `question_${params.questionNumber}`, updateValue: true, note: e,
            });
        }
    };

    checkForQuestionsRequiredApproval = () => {
        let requireApproval = false;
        for (let question = 1; question <= 46; question++) {
            if
            (
                this.props.blemish_report.questions
                && (this.props.blemish_report.questions[`question_${question}`].category === 4 || this.props.blemish_report.questions[`question_${question}`].category === 5)
                && this.props.blemish_report.questions[`question_${question}`].value === true
            ) {
                requireApproval = true;
            }
        }
        return requireApproval;
    };

    questionsOnThePage = (from, to) => {
        const content = [];

        if (to === undefined) {
            if (from === 46) {
                if (this.checkForQuestionsRequiredApproval()) {
                    content.push(
                        <div
                            key={this.props.blemish_report.questions[`question_${from}`].position}
                        >
                            <p style={{ fontWeight: '500', textAlign: 'justify' }}>
                                Thank you for answering your questions. Based upon your answers I need to get approval from my manager. If approved, I just need to make you aware it is essential the
                                bike
                                is not started on the day of collection as the oil must be completely cold, our drivers will be unable to carry out the physical assessment if the bike has been
                                recently
                                started.
                            </p>
                            <Button
                                onClick={el => this.finishBlemishReport(el, from)}
                                style={{ display: 'block', margin: '20px auto 0' }}
                                htmlType="button"
                                type="primary"
                                name="confirm"
                            >
                                Finish blemish report
                            </Button>
                        </div>,
                    );
                } else {
                    content.push(
                        <div
                            key={this.props.blemish_report.questions[`question_${from}`].position}
                        >
                            <p style={{ fontWeight: '500', textAlign: 'justify' }}>{this.props.blemish_report.questions[`question_${from}`].title}</p>
                            <Button
                                onClick={el => this.finishBlemishReport(el, from)}
                                style={{ display: 'block', margin: '20px auto 0' }}
                                htmlType="button"
                                type="primary"
                                name="confirm"
                            >
                                Finish blemish report
                            </Button>
                        </div>,
                    );
                }
            } else {
                content.push(
                    <div
                        key={this.props.blemish_report.questions[`question_${from}`].position}
                    >
                        <p style={{ fontWeight: '500', textAlign: 'justify' }}>{this.props.blemish_report.questions[`question_${from}`].title}</p>
                        <Button
                            disabled={this.is_blemish_report_failed}
                            onClick={el => this.next(el, from)}
                            style={{ display: 'block', margin: '20px auto 0' }}
                            htmlType="button"
                            type="primary"
                            name="confirm"
                        >
                            Confirm
                        </Button>
                    </div>,
                );
            }
        } else {
            for (let i = from; i <= to; i++) {
                if (this.props.blemish_report.questions[`question_${i}`].category === 1) {
                    if (i === 11 && this.props.blemish_report.questions[`question_${i - 1}`].value !== true) {
                        content.push(
                            <div
                                key={this.props.blemish_report.questions[`question_${i}`]._id}
                            >
                                <p style={{ fontWeight: '500', textAlign: 'justify' }}>{this.props.blemish_report.questions[`question_${i}`].title}</p>
                                <Button
                                    disabled
                                    onClick={el => this.next(el, i)}
                                    style={{ display: 'block', margin: '20px auto 0' }}
                                    htmlType="button"
                                    type="primary"
                                    name="confirm"
                                >
                                    Confirm
                                </Button>
                            </div>,
                        );
                    } else {
                        content.push(
                            <div
                                key={this.props.blemish_report.questions[`question_${i}`]._id}
                            >
                                <p style={{ fontWeight: '500', textAlign: 'justify' }}>{this.props.blemish_report.questions[`question_${i}`].title}</p>
                                <Button
                                    onClick={el => this.next(el, i)}
                                    style={{ display: 'block', margin: '20px auto 0' }}
                                    htmlType="button"
                                    type="primary"
                                    name="confirm"
                                >
                                    Confirm
                                </Button>
                            </div>,
                        );
                    }
                } else if (this.props.blemish_report.questions[`question_${i}`].category === 2) {
                    content.push(
                        <div
                            style={{ marginBottom: 10 }}
                            key={this.props.blemish_report.questions[`question_${i}`]._id}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ flexBasis: 450 }}>{this.props.blemish_report.questions[`question_${i}`].title}</span>
                                <RadioGroup
                                    disabled={this.is_blemish_report_failed}
                                    name="critical"
                                    defaultValue={this.props.blemish_report.questions[`question_${i}`].value}
                                    ref={element => this.refArray[`question_${i}`] = element}
                                >
                                    <Radio value={false} onClick={e => this.showDeleteConfirm(e, { questionNumber: i })}>No</Radio>
                                    <Radio value onChange={e => this.questionAnswer(e, { questionNumber: i })}>Yes</Radio>
                                </RadioGroup>


                            </div>
                            <span hidden={this.props.blemish_report.questions[`question_${i}`].value !== false} style={{ fontStyle: 'italic', color: 'red' }}>Sorry, cause of this issue we can't buy your bike</span>
                        </div>,
                    );
                } else if (this.props.blemish_report.questions[`question_${i}`].category === 3) {
                    content.push(
                        <div
                            style={{ marginBottom: 10 }}
                            key={this.props.blemish_report.questions[`question_${i}`]._id}
                        >
                            <span>{this.props.blemish_report.questions[`question_${i}`].title}</span>
                            {(i === 9)
                                ? (
                                    <Search
                                        type="number"
                                        disabled={this.is_blemish_report_failed}
                                        style={{ marginTop: 5 }}
                                        placeholder="Type answer here. Use enter on the keyboard or click the send button to save answer"
                                        enterButton="Send"
                                        size="small"
                                        defaultValue={this.props.blemish_report.questions[`question_${i}`].note}
                                        onSearch={value => this.questionAnswer(value, { questionNumber: i })}
                                    />
                                )
                                : (
                                    <Search
                                        disabled={this.is_blemish_report_failed}
                                        style={{ marginTop: 5 }}
                                        placeholder="Type answer here. Use enter on the keyboard or click the send button to save answer"
                                        enterButton="Send"
                                        size="small"
                                        defaultValue={this.props.blemish_report.questions[`question_${i}`].note}
                                        onSearch={value => this.questionAnswer(value, { questionNumber: i })}
                                    />
                                )
                            }

                        </div>,
                    );
                } else if (this.props.blemish_report.questions[`question_${i}`].category === 4) {
                    content.push(
                        <div
                            style={{ marginBottom: 10 }}
                            key={this.props.blemish_report.questions[`question_${i}`]._id}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ flexBasis: 450 }}>{this.props.blemish_report.questions[`question_${i}`].title}</span>
                                <RadioGroup
                                    disabled={this.is_blemish_report_failed}
                                    name="price adjustment"
                                    defaultValue={this.props.blemish_report.questions[`question_${i}`].value}
                                    onChange={e => this.questionAnswer(e, { questionNumber: i })}
                                >
                                    <Radio value={false}>No</Radio>
                                    <Radio value>Yes</Radio>
                                </RadioGroup>
                            </div>
                            <span
                                hidden={!this.props.blemish_report.questions[`question_${i}`].price_adjustment_required}
                                style={{ fontStyle: 'italic', color: 'blue' }}
                            >
                                Due to this, we need to adjust price
                            </span>
                        </div>,
                    );
                } else if (this.props.blemish_report.questions[`question_${i}`].category === 5) {
                    content.push(
                        <div
                            style={{ marginBottom: 10 }}
                            key={this.props.blemish_report.questions[`question_${i}`]._id}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ flexBasis: 450 }}>{this.props.blemish_report.questions[`question_${i}`].title}</span>
                                <RadioGroup
                                    disabled={this.is_blemish_report_failed}
                                    name="photo required"
                                    defaultValue={this.props.blemish_report.questions[`question_${i}`].value}
                                    onChange={e => this.questionAnswer(e, { questionNumber: i })}
                                >
                                    <Radio value={false}>No</Radio>
                                    <Radio value>Yes</Radio>
                                </RadioGroup>
                            </div>
                            <span
                                hidden={!this.props.blemish_report.questions[`question_${i}`].additional_photos_required}
                                style={{ fontStyle: 'italic', color: 'orange' }}
                            >
                                Due to this, we will need additional photos from customer
                            </span>
                        </div>,
                    );
                } else if (this.props.blemish_report.questions[`question_${i}`].category === 6) {
                    content.push(
                        <div
                            style={{ marginBottom: 10, display: 'flex', justifyContent: 'space-between' }}
                            key={this.props.blemish_report.questions[`question_${i}`]._id}
                        >
                            <span style={{ flexBasis: 450 }}>{this.props.blemish_report.questions[`question_${i}`].title}</span>
                            <RadioGroup
                                disabled={this.is_blemish_report_failed}
                                name="buy anyway"
                                defaultValue={this.props.blemish_report.questions[`question_${i}`].value}
                                onChange={e => this.questionAnswer(e, { questionNumber: i })}
                            >
                                <Radio value={false}>No</Radio>
                                <Radio value>Yes</Radio>
                            </RadioGroup>
                        </div>,
                    );
                } else if (this.props.blemish_report.questions[`question_${i}`].category === 7) {
                    content.push(
                        <div
                            style={{ marginBottom: 10 }}
                            key={this.props.blemish_report.questions[`question_${i}`]._id}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ flexBasis: 450 }}>{this.props.blemish_report.questions[`question_${i}`].title}</span>
                                <RadioGroup
                                    disabled={this.is_blemish_report_failed}
                                    name="photo required"
                                    defaultValue={this.props.blemish_report.questions[`question_${i}`].value}
                                    onChange={e => this.questionAnswer(e, { questionNumber: i, question: this.props.blemish_report.questions[`question_${i}`] })}
                                >
                                    <Radio value={false}>No</Radio>
                                    <Radio value>Yes</Radio>
                                </RadioGroup>
                            </div>

                            <div hidden={!this.props.blemish_report.questions[`question_${i}`].value}>
                                <Search
                                    disabled={this.is_blemish_report_failed}
                                    style={{ marginTop: 5 }}
                                    placeholder="Type answer here. Use enter on the keyboard or click the send button to save answer"
                                    enterButton="Send"
                                    size="small"
                                    defaultValue={this.props.blemish_report.questions[`question_${i}`].note}
                                    onSearch={value => this.questionAnswer(value, { questionNumber: i })}
                                />
                            </div>
                        </div>,
                    );
                }
            }
        }
        return content;
    };

    stepsFromBlemishReport = [
        {
            title: '',
            content:
    <div>
        {this.questionsOnThePage(1)}
    </div>,
        },
        {
            title: '',
            content:
    <div>
        {this.questionsOnThePage(2, 9)}
    </div>,
        },
        {
            title: '',
            content:
    <div>
        {this.questionsOnThePage(10, 11)}
    </div>,
        },
        {
            title: '',
            content:
    <div>
        {this.questionsOnThePage(12, 13)}
    </div>,
        },
        {
            title: '',
            content:
    <div>
        {this.questionsOnThePage(14)}
    </div>,
        },
        {
            title: '',
            content:
    <div>
        {this.questionsOnThePage(15, 23)}
    </div>,
        },
        {
            title: '',
            content:
    <div>
        {this.questionsOnThePage(24, 32)}
    </div>,
        },
        {
            title: '',
            content:
    <div>
        {this.questionsOnThePage(33, 38)}
    </div>,
        },
        {
            title: '',
            content:
    <div>
        {this.questionsOnThePage(39, 45)}
    </div>,
        },
        {
            title: '',
            content:
    <div>
        {
            (this.props.Leads.Lead_profile && this.props.Leads.Lead_profile.Lead_valuations && this.props.Leads.Lead_profile.Lead_valuations.valuations.length !== 0)
                        && (
                            <Fragment>
                                {
                                    (this.props.Leads.Lead_profile.Lead_valuations && this.props.Leads.Lead_profile.Lead_valuations.customer_valuation && this.props.Leads.Lead_profile.Lead_valuations.customer_valuation !== 0)
                                && (
                                    <p>
                                        Customer Looking For:
                                        <span style={{ fontStyle: 'italic' }}>
                                            &pound;
{this.props.Leads.Lead_profile.Lead_valuations.customer_valuation}
                                        </span>
                                    </p>
                                )
                                }
                                <div style={{ display: 'flex', margin: '5px 0 15px' }}>
                                    <span style={{ flexBasis: 140 }}>Update Valuation:</span>
                                    <Search
                                        disabled={this.is_blemish_report_failed}
                                        type="number"
                                        style={{ marginBottom: 5 }}
                                        defaultValue={this.props.Leads.Lead_profile.Lead_valuations.valuations[0].valuation}
                                        placeholder="Use enter on the keyboard or click the send button to update the valuation"
                                        enterButton="Update"
                                        size="small"
                                        onSearch={value => this.questionAnswer(value, { price_negotiate: true })}
                                    />
                                </div>
                            </Fragment>
                        )
        }
        {this.questionsOnThePage(46)}

    </div>,
        },
    ];

    previousStep = () => {
        const currentStep = this.state.current;

        this.setState({ current: currentStep - 1 });
    };

    startingStep = () => {
        let startStep = 0;

        const stepsArray = [
            this.divideQuestionsBySteps(1),
            this.divideQuestionsBySteps(2, 9),
            this.divideQuestionsBySteps(10, 11),
            this.divideQuestionsBySteps(12, 13),
            this.divideQuestionsBySteps(14),
            this.divideQuestionsBySteps(15, 23),
            this.divideQuestionsBySteps(24, 32),
            this.divideQuestionsBySteps(33, 38),
            this.divideQuestionsBySteps(39, 45),
            this.divideQuestionsBySteps(46),

        ];

        let finished = true;
        outer: for (let step = 0; step < stepsArray.length; step++) {
            for (let question = 0; question < stepsArray[step].length; question++) {
                if (stepsArray[step][question].value === null) {
                    startStep = step;
                    finished = false;
                    break outer;
                }
                if (stepsArray[step][question].category === 7 && stepsArray[step][question].value === true && !stepsArray[step][question].note) {
                    startStep = step;
                    finished = false;
                    break outer;
                }
            }
        }

        if (finished) {
            startStep = 9;
        }

        this.setState({ current: startStep });

        return startStep;
    };

    checkAllStepQuestionsNotAnswered = questions => questions.some(question => question.value === null);

    render() {
        const { current } = this.state;

        return (
            <div>
                <Steps current={current} size="small">
                    {this.stepsFromBlemishReport.map(item => <Step key={Math.random()} title={item.title} />)}
                </Steps>
                <div style={this.stepsStyles.stepsContent}>
                    {
                        this.is_blemish_report_failed
                        && (
                            <Fragment>
                                <h4>
                                    Blemish report -&nbsp;
                                    <span style={{ color: 'red', fontStyle: 'italic' }}>
                                        Failed&nbsp;
                                        {(this.props.Leads.Lead_profile.Lead_general.approval && this.props.Leads.Lead_profile.Lead_general.approval.blemish_report.value === false) && 'by denied approval for blemish report'}
                                    </span>
                                </h4>
                                <p style={{ fontStyle: 'italic', fontWeight: 'bold' }}>Unfortunately, based upon the answers you have given me, I cannot proceed with the purchase of this bike.</p>
                            </Fragment>
                        )
                    }
                    {this.stepsFromBlemishReport[current].content}
                </div>
                <div className="steps-action" style={this.stepsStyles.stepsAction}>
                    <div className="sf-btn-toolbar">
                        {
                            !this.is_blemish_report_failed
                            && current > 0
                            && this.props.blemish_report.questions.question_46.value === null
                            && (
                                <SFButton style={{ marginRight: 8 }} onClick={this.previousStep}>
                                    Previous
                                </SFButton>
                            )
                        }
                        {
                            !this.is_blemish_report_failed
                            && current < this.stepsFromBlemishReport.length - 1
                            && <SFButton type="primary" disabled={this.checkAllStepQuestionsNotAnswered(this.stepsArray[current])} onClick={this.next}>Next</SFButton>
                        }
                    </div>
                    {
                        this.is_blemish_report_failed
                        && !this.props.Leads.Lead_profile.Lead_general.approval.blemish_report.requires_approval
                        && this.props.Leads.Lead_profile.Lead_general.approval.blemish_report.value === undefined
                        && (
                            <SFButton
                                type="primary"
                                onClick={
                                    () => {
                                        this.props.getLeadProfileRequest(this.props.lead_id);
                                        this.props.closeModal();
                                    }
                                }
                            >
                                Finish Blemish Report
                            </SFButton>
                        )
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    currentUserId: get(state.App, 'App_content.user._id'),
    lead_id: getVal(state, 'Leads.Lead_profile.Lead_general.root_id'),
    Leads: state.Leads,
    blemish_report: state.Leads.Lead_profile.Lead_blemish_report.blemish_report,
    blemish_report_status_id: getVal(state, 'Leads.Lead_profile.Lead_blemish_report.blemish_report.ref_lead_blemish_report_status'),
});

export default connect(mapStateToProps, {
    updateBlemishReportRequest, getLeadProfileRequest, setLeadValuationRequest, setLeadsCustomerValuationRequest,
})(BlemishReportVersion2);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_blemish_report/components/BlemishReportVersion2.js